<template>
  <div>
    <v-navigation-drawer
      v-model="isOpen"
      :width="$isMobile ? '100%' : '50%'"
      right
      fixed
      :permanent="isOpen"
      hide-overlay
      class="z-index--100">
      <div class="ma-3">
        <div class="d-flex">
          <v-btn
            dark
            fab
            x-small
            outlined
            color="primary"
            class="mr-3"
            @click="close"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <div class="subtitle-1 primary--text">
            {{ product.product ? product.product.name : '' }}
          </div>
        </div>
        <div>
          <div>
            <v-row>
              <v-col md="12">
                <div>
                  Marca: {{ product.brand || 'Sin marca' }}
                </div>
              </v-col>

              <v-col md="12">
                <v-card outlined>
                  <div class="d-flex">
                    <v-col>
                      <div class="mb-2">
                        Departamento
                      </div>
                      <div v-if="product.product && product.product.category">
                        {{ product.product.category.name }}
                      </div>
                    </v-col>
                    <v-divider vertical />
                    <v-col>
                      <div class="mb-2">
                        Código SAT
                      </div>
                      <div>
                        {{ product.satCode }}
                      </div>
                    </v-col>
                  </div>
                </v-card>
              </v-col>

              <v-col md="12">
                <v-card outlined>
                  <div class="d-flex">
                    <v-col>
                      <div class="mb-2">
                        Presentación
                      </div>
                      <div v-if="product.displayUnit">
                        {{ product.displayQuantity }} {{ product.displayUnit.name }}
                      </div>
                    </v-col>
                    <v-divider vertical />
                    <v-col>
                      <div class="mb-2">
                        Contenido
                      </div>
                      <div v-if="product.contentUnit">
                        {{ product.contentQuantity }} {{ product.contentUnit && product.contentUnit.name ? product.contentUnit.name : variant.displayUnit.name }}
                      </div>
                    </v-col>
                  </div>
                </v-card>
              </v-col>

              <v-col md="12">
                <v-card outlined>
                  <div class="d-flex">
                    <v-col>
                      <div class="mb-2">
                        Precio sin impuestos
                      </div>
                      <div class="align-right">
                        {{ product.amount | toFixNumber(2) | numberWithComma | prefix('$') }}
                      </div>
                    </v-col>
                    <v-divider vertical />
                    <v-col>
                      <div class="mb-2">
                        Precio con impuestos
                      </div>
                      <div class="align-right">
                        {{ product.netTotal | toFixNumber(2) | numberWithComma | prefix('$') }}
                      </div>
                    </v-col>
                  </div>
                </v-card>
              </v-col>

              <v-col md="12">
                <div class="mb-3">
                  Impuestos
                </div>
                <v-data-table
                  :loading-text="table.title"
                  :loading="table.loading"
                  :headers="table.headers"
                  :items="product.taxes"
                  :items-per-page="table.itemsPerPage"
                  :page="table.page"
                  hide-default-footer
                  dense
                  class="elevation-1">
                  <template v-slot:item.isRetention="{ item }">
                    {{ item.isRetention ? 'Retenido' : 'Trasladado' }}
                  </template>
                  <template v-slot:item.isQuota="{ item }">
                    {{ item.isQuota ? 'Cuota' : 'Tasa' }}
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
    </v-navigation-drawer>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
export default {
  name: 'Product',
  props: {
    product: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      table: {
        title: this.$i18n.t('products.sidePanel.loading'),
        loading: false,
        headers: [
          { text: this.$i18n.t('products.sidePanel.headers.kind'), value: 'kind' },
          { text: this.$i18n.t('products.sidePanel.headers.isRetention'), value: 'isRetention' },
          { text: this.$i18n.t('products.sidePanel.headers.isQuota'), value: 'isQuota' },
          { text: this.$i18n.t('products.sidePanel.headers.base'), value: 'base' }
        ],
        data: [],
        total: 0,
        itemsPerPage: 15,
        page: 1
      },
      variant: {}
    }
  },
  watch: {
    product: async function (value) {
      const data = cloneDeep(value)
      if (!data.displayUnit.name) this.variant = await this.$api.get(`/v1/catalog/${data._id}`)
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keyDownHandler)
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
  methods: {
    keyDownHandler (event) {
      if (event.code === 'Escape') this.isOpen = false
    },
    open () {
      this.isOpen = true
    },
    close () {
      this.isOpen = false
    }
  }
}
</script>
